module.exports = __webpack_public_path__ + "static/media/CuramLife_Homebase_Icon.f7f2e119.png";